export default {
   makeNotification(state, value) {
      state.hasNotification = value;
   },

   makeNotificationSound(state, value) {
      state.hasSoundEffect = value;
   }
}